import { NectarTasksAllDone } from '@/features/nectar/components/NectarTasksAllDone'
import { formValuesToUserProfile, useProfile, userProfileToFormValues } from '@/features/profile/api/profile'
import { ProfileDetailsForm, ProfileDetailsFormValues } from '@/features/profile/ProfileDetailsForm'
import { Spinner } from '@/ui-kit'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { useSubmitMissionProfile } from '../api'
import { Mission } from '../api/models'
import { useMissionsUrl } from '../context/MissionsUrlProvider'

type MissionDemographicsFormProps = {
  mission: Mission
}

export const MissionDemographicsForm = ({ mission }: MissionDemographicsFormProps) => {
  const { missionsUrl } = useMissionsUrl()

  const navigate = useNavigate()
  const { data: profile, isLoading } = useProfile()
  const { mutateAsync: submitMissionProfile, isPending: isSubmittingProfile } = useSubmitMissionProfile()

  const onSubmit = async (data: ProfileDetailsFormValues) => {
    try {
      await submitMissionProfile({
        missionId: mission.id,
        data: formValuesToUserProfile(data)
      })
      navigate(missionsUrl)
      toast.success('Mission submitted successfully')
    } catch (error) {
      console.error(error)
      toast.error('Failed to submit mission')
    }
  }

  return isLoading ? (
    <div className="flex justify-center py-12">
      <Spinner />
    </div>
  ) : mission.view.nextSubmissionAvailable ? (
    <div className="max-w-[900px]">
      <ProfileDetailsForm
        onSubmit={onSubmit}
        defaultValues={profile ? userProfileToFormValues(profile) : undefined}
        isSubmittingProfile={isSubmittingProfile}
      />
    </div>
  ) : (
    <div className="m-auto">
      <NectarTasksAllDone name={mission.title} />
    </div>
  )
}
